import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { push } from "connected-react-router";
import { withRouter } from "react-router-dom";

import UserUtils from "services/user/utils";

import HalfLayout from "components/HalfLayout";
import RocketLayout from "components/RocketLayout";
import LoginLayout from "./components/LoginLayout";

class LoginScene extends React.Component {
  componentWillMount = () => {
    const { user } = this.props;

    if (this.props.isAuthenticated) {
      this.props.push(UserUtils.getDefaultRoute(user));
    }
  };

  render() {
    return (
      <HalfLayout
        leftComponent={<RocketLayout location={this.props.location} />}
        rightComponent={<LoginLayout location={this.props.location} />}
      />
    );
  }
}

LoginScene.defaultProps = {
  isAuthenticated: false,
};

LoginScene.propTypes = {
  isAuthenticated: PropTypes.bool,
  push: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.Authentication.isAuthenticated,
  user: state.User,
});

const mapDispatchToProps = (dispatch) => ({
  push: (route) => dispatch(push(route)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginScene)
);
